<template>
  <vs-card>
    <p class="font-z-1">
      Agregaremos firmas en la última hoja de tu documento, para evitar ponerlas sobre el texto, selecciona la posición adecuada:
      <br><br>
    </p>

    <vs-row>
      <vs-col class="my-3" vs-type="grid" vs-justify="center" vs-align="center" vs-w="6">
        <img src="@/assets/images/document/upper-left.svg" width="70" class="d-block m-auto" alt="">
        <vs-radio class="mt-3" v-model="signPositionRadio" vs-name="signPosition" vs-value="UPPER_LEFT" @change="setSignPosition(signPositionRadio)">Arriba a la izquierda</vs-radio>
      </vs-col>

      <vs-col class="my-3" vs-type="grid" vs-justify="center" vs-align="center" vs-w="6">
        <img src="@/assets/images/document/upper-right.svg" width="70" class="d-block m-auto" alt="">
        <vs-radio class="mt-3" v-model="signPositionRadio" vs-name="signPosition" vs-value="UPPER_RIGHT" @change="setSignPosition(signPositionRadio)">Arriba a la derecha</vs-radio>

      </vs-col>

      <vs-col class="my-3" vs-type="grid" vs-justify="center" vs-align="center" vs-w="6">
        <img src="@/assets/images/document/lower-left.svg" width="70" class="d-block m-auto" alt="">
        <vs-radio class="mt-3" v-model="signPositionRadio" vs-name="signPosition" vs-value="LOWER_LEFT" @change="setSignPosition(signPositionRadio)">Abajo a la izquierda</vs-radio>

      </vs-col>

      <vs-col class="my-3" vs-type="grid" vs-justify="center" vs-align="center" vs-w="6">
        <img src="@/assets/images/document/lower-right.svg" width="70" class="d-block m-auto" alt="">
        <vs-radio class="mt-3" v-model="signPositionRadio" vs-name="signPosition" vs-value="LOWER_RIGHT" @change="setSignPosition(signPositionRadio)">Abajo a la derecha</vs-radio>

      </vs-col>

      <vs-col class="my-3" vs-type="grid" vs-justify="center"  vs-align="center" vs-w="12">
        <p class="font-z-1 mb-2">Crear una hoja extra dedicada a las firmas: <span class="badge badge-primary badge-sm badge-text">Recomendado</span></p>
        <vs-radio class="d-block m-auto" v-model="signPositionRadio" vs-name="signPosition" vs-value="NONE" @change="setSignPosition(signPositionRadio)">Crear una hoja extra</vs-radio>

      </vs-col>

      <vs-col class="my-3" vs-type="grid" vs-justify="center" vs-align="center" vs-w="12">
        <feather-icon icon="MapPinIcon" svgClasses="w-16 h-16 text-primary d-block m-auto mb-1" />
        <p class="font-z-1 mb-2">Define coordenadas exactas por firmante.</p>
        <vs-radio class="d-block m-auto" v-model="signPositionRadio" vs-name="signPosition" vs-value="CUSTOM" @change="setSignPosition(signPositionRadio)">Personalizado</vs-radio>
      </vs-col>

    </vs-row>

    <!--{{signPositionRadio}}-->
    <div slot="footer">
      <vs-row vs-justify="flex-end">
        <vs-button @click="submitNewDocument('PDF_SIGNATURE')" type="filled" color="primary">Seleccionar</vs-button>
      </vs-row>
    </div>
  </vs-card>
</template>

<script>
export default {
  name: "SignPositionSelector",
  props: ['setSignPosition', 'submitNewDocument'],
  data() {
    return {
      signPositionRadio: 'NONE'
    }
  },
}
</script>

<style scoped>

</style>
